// ===================================================
// vBlock — סולם השכבות, נגזר מן המרשם המרכזי
// ===================================================
//
// עד 06.09.2026 היה כאן סולם מקומי משלו — 1 עד 1001 — שלא ידע דבר
// על שאר המוצר. הוא נראה גבוה מבפנים ונמדד נמוך מבחוץ: תפריט הקשר
// ביקש 100 בעוד מסגרת העמוד יושבת על 1000, ולכן התפריט נפתח מאחוריה.
//
// הקבועים כאן שומרים בדיוק על אותם שמות, כדי ששני הצרכנים
// (vBlockShell · vBlockContextMenu) לא ישתנו — אבל הערכים נגזרים
// עכשיו מ-src/lib/ui/layers.ts, שהוא מקור האמת היחיד.
//
// שתי משפחות, ובכוונה:
//   • ארבעת הראשונים נשארים קטנים — הם מסדרים בלוקים זה מול זה
//     בתוך הזרימה של הקנבס, ואין להם עסק עם שאר המסך.
//   • ארבעת האחרונים הם משטחים צפים — הם עוזבים את הזרימה דרך
//     portal אל body, ולכן חייבים לדבר בשפת המרשם.
//
// המסך המלא יושב על תקרת האפליקציה ולא מעליה, כדי שתפריט הקשר
// שנפתח בתוכו יעבור אותו. זה בדיוק הכשל שהוא בא למנוע.

import { Z } from "@/lib/ui/layers";

export const VBLOCK_Z = {
  // בתוך הזרימה — בלוק מול בלוק
  block: Z.base + 1,
  blockHover: Z.base + 2,
  blockFocused: Z.base + 5,
  blockDragging: Z.raised,

  // מחוץ לזרימה — portal אל body
  fullscreenOverlay: Z.appCeiling,
  fullscreenContent: Z.appCeiling + 1,
  contextMenu: Z.popover,
  tooltip: Z.tooltip,
} as const;
